import cookie from 'cookie';
import Gateway from '../Gateway';

export default class CookieStorage {
  get key() {
    throw new Error('Key is not defined');
  }

  get _defaultValue() {
    throw new Error('Default Value is not defined');
  }

  get value() {
    return this.data;
  }

  _save() {
    Gateway.window.document.cookie = cookie.serialize(this.key, this.data);
  }
}
